export class Student {
    constructor(
        public id: number,
        public firstName: string,
        public lastName: string,
        public company: string,
        public companyName: string,
        public city: string,
        public countryCode: string,
        public zipCode: string,
        public phone: string,
        public title: string,
        public job: string,
        public companyId: number,
        public interne: boolean,
        public email: string
    ) {}
}

export interface StudentHistory {
    session: Array<{
        id: number;
        training: string;
        startDate: string;
    }>;
}



// WEBPACK FOOTER //
// ./src/app/_services/directory/student/student.model.ts